import type {
    PS,
    CanvasAnimationOptions,
    ScrubTriggerVariant,
    ScrubEffectData,
    Pointer
} from '@wix/document-services-types'

const play = (ps: PS, compPointer: Pointer, animation: CanvasAnimationOptions) => {
    return ps.siteAPI.canvas.play(compPointer, animation)
}
const cancel = (ps: PS, compPointer: Pointer) => {
    return ps.siteAPI.canvas.cancel(compPointer)
}
const cancelAll = (ps: PS) => {
    return ps.siteAPI.canvas.cancelAll()
}
const update = (ps: PS, compPointer: Pointer, overrides: Partial<CanvasAnimationOptions>) => {
    return ps.siteAPI.canvas.update(compPointer, overrides)
}
const addCustomEffect = (ps: PS, compPointer: Pointer, trigger: ScrubTriggerVariant, animation: ScrubEffectData) => {
    return ps.siteAPI.canvas.addCustomEffect(compPointer, trigger, animation)
}
const updateCustomEffect = (
    ps: PS,
    compPointer: Pointer,
    trigger: ScrubTriggerVariant,
    animation: Partial<ScrubEffectData>
) => {
    return ps.siteAPI.canvas.updateCustomEffect(compPointer, trigger, animation)
}

const removeCustomEffects = (ps: PS, compPointer: Pointer, trigger?: ScrubTriggerVariant) => {
    return ps.siteAPI.canvas.removeCustomEffects(compPointer, trigger)
}

export default {
    play,
    cancel,
    cancelAll,
    update,
    addCustomEffect,
    updateCustomEffect,
    removeCustomEffects
}
